import Button from "../../../../shared/components/Button";
import { useAuth } from "../../../auth/shared/hooks/useAuth";
import { getLeagueTexts } from "../../shared/leagueTexts";
import LeagueDirectory from "../../shared/components/LeagueDirectory";
import LeagueLayout from "../../shared/components/LeagueLayout";

export default function LeaguesPage() {
  const { isStaff } = useAuth();
  const t = getLeagueTexts();
  return <LeagueLayout>
    {isStaff && <div className="league-actions"><Button href="#/organizador/ligas">{t.manage}</Button></div>}
    <LeagueDirectory />
  </LeagueLayout>;
}
